import React from 'react';
import Bone from 'app/shared/components/Bone';
import { useSelector } from 'react-redux';

import {
    AppSelectors,
} from 'app/shared/selectors';

import {
    Flex,
    Table,
} from '@zillow/constellation';

// styled components
import {
    StyledPropertyRow,
    StyledPropertyAddress,
} from 'app/shared/components/soh/PropertyRow/StyledComponents';

import {
    StyledPropertyRowSkeletonPhotoContainer,
} from './StyledComponents';

const PropertyRowSkeleton = () => {
    const isScreenTabletOrDesktop = useSelector(state => AppSelectors.makeIsScreenTabletOrDesktop(state));
    const isScreenDesktop = useSelector(state => AppSelectors.makeIsScreenDesktop(state));
    const isEnterpriseCustomer = useSelector(state => state.user.isEnterpriseCustomer);

    const show3D = !isEnterpriseCustomer || isScreenDesktop;

    return (
        <StyledPropertyRow>
            <Table.Cell>
                <StyledPropertyRowSkeletonPhotoContainer>
                    <Bone type="bar" cover={true} dark={true} />
                </StyledPropertyRowSkeletonPhotoContainer>
            </Table.Cell>
            {isScreenTabletOrDesktop && (
                <React.Fragment>
                    <Table.Cell>
                        <Bone type="line" dark={true} />
                        <StyledPropertyAddress marginTop={true}>
                            <Flex flex="1">
                                <Bone type="line" dark={true} />
                            </Flex>
                            <div>
                                <Bone type="line" dark={true} />
                            </div>
                            <div>
                                <Bone type="line" dark={true} />
                            </div>
                        </StyledPropertyAddress>
                    </Table.Cell>
                    {show3D && (
                        <React.Fragment>
                            <Table.Cell>
                                <Bone type="line" dark={true} />
                            </Table.Cell>
                        </React.Fragment>
                    )}
                    <Table.Cell>
                        <Bone type="line" dark={true} />
                    </Table.Cell>
                    <Table.Cell>
                        <Bone type="line" dark={true} />
                    </Table.Cell>
                </React.Fragment>
            )}
            {isEnterpriseCustomer && (
                <React.Fragment>
                    <Table.Cell>
                        <Bone type="line" dark={true} />
                    </Table.Cell>
                    <Table.Cell>
                        <Bone type="line" dark={true} />
                    </Table.Cell>
                </React.Fragment>
            )}
        </StyledPropertyRow>
    );
};

export default PropertyRowSkeleton;
